interface ImageTypeMetadata {
  mimeType: MimeType;
  fileType: string;
}

export type MimeType =
  | "image/png"
  | "image/gif"
  | "image/jpeg"
  | "image/svg+xml";

export const generateImageSourceString = (
  mimeType: MimeType,
  imageData: string
) => {
  return `data:${mimeType};base64,${imageData}`;
};

const imageTypeMetadataMap = new Map<string, ImageTypeMetadata>();

imageTypeMetadataMap.set("png", { mimeType: "image/png", fileType: ".png" });
imageTypeMetadataMap.set("jpeg", { mimeType: "image/jpeg", fileType: ".jpg" });
imageTypeMetadataMap.set("gif", { mimeType: "image/gif", fileType: ".gif" });
imageTypeMetadataMap.set("svg", {
  mimeType: "image/svg+xml",
  fileType: ".svg",
});

export { imageTypeMetadataMap };
